import {routeIndexName} from '@/services/auth-service';

export default async function guest({next, router}) {
    if (localStorage.getItem('vue-token')) {
        return router.push({name: await routeIndexName()});
    }
    return next();
}
